import { makeVar } from '@apollo/client'

export type ProductSearchBarState = {
    selection: Record<string, string[]>
    sorting: { display: string; value: string }[]
    grouping: Record<string, boolean>
}

const DEFAULT_PRODUCT_SEARCH_BAR_STATE: ProductSearchBarState = {
    selection: {},
    sorting: [],
    grouping: { sectionNumber: false, productType: false },
}

export const productSearchBarReactiveVar = makeVar<ProductSearchBarState>(
    DEFAULT_PRODUCT_SEARCH_BAR_STATE
)

export const setSelection = (selection?: Record<string, string[]>) => {
    const current = productSearchBarReactiveVar()

    productSearchBarReactiveVar({ ...current, selection: selection ?? {} })
}

export const setSortingGrouping = ({ sorting, collapseColumnChecked }: any) => {
    const current = productSearchBarReactiveVar()
    const allowedColumns = [
        'firmDisplayName',
        'type',
        'sectionName', // sectionNumber in card view
        'productType',
        'submissionStatus',
        'lastUpdated',
        'isActive',
    ]

    productSearchBarReactiveVar({
        ...current,
        grouping: collapseColumnChecked,
    })
}
